// extracted by mini-css-extract-plugin
module.exports = {"itemShow":"ItemShow_itemShow__2SRUr","leftItemShow":"ItemShow_leftItemShow__2n6PC","usingTrends":"ItemShow_usingTrends__2eW91"};